'use strict';
interface Window {
  ROOT: any
}
declare var window: Window;
declare var ROOT: any;

window.ROOT = window.ROOT || {};
ROOT.isDebug = location.hash == '#debug';
if (location.href.indexOf('localhost') !== -1 || location.href.indexOf('192.168') !== -1){
  ROOT.isDebug = true;
}
if (ROOT.isDebug) {
  document.querySelector('html').classList.add('debug');
}

import 'lazysizes';
// import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Scroll from './module/_scroll';
import Resize from './module/_resize';



// init
(function () {
  const { EventEmitter } = require('events');
  ROOT.ev = new EventEmitter();
  ROOT.scroll = new Scroll();
  ROOT.resize = new Resize();


  // メニュー
  var btnOpen = document.querySelector('.btn-menu-open');
  var header = document.querySelector('.header');
  btnOpen.addEventListener("click",function(){
    header.classList.toggle("open");
  });
  var menuHideBtn = document.querySelector('.bg-menu');
  menuHideBtn.addEventListener("click",function(){
    header.classList.remove("open");
  });

  Array.from(document.querySelectorAll('.btn-menu-link')).forEach(item=>{
    item.addEventListener("click",()=>{
      header.classList.remove("open");
    })
  })


})();

